var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, useRef } from "react";
import { Tabs, makeStyles, Tab, Divider, Box, } from "@material-ui/core";
import { palette } from "../../shared/theme";
export default (_a) => {
    var { value, variant = "scrollable", scrollButtons = "auto" } = _a, props = __rest(_a, ["value", "variant", "scrollButtons"]);
    const tabIndicatorRef = useRef(null);
    const [tabIndicatorWidth, setTabIndicatorWidth] = useState(0);
    const classes = useStyles();
    useEffect(() => {
        var _a;
        if (tabIndicatorRef.current) {
            const tabsContainer = variant === "scrollable"
                ? tabIndicatorRef.current.querySelector("div.MuiTabs-scroller > .MuiTabs-flexContainer")
                : (_a = tabIndicatorRef.current.firstElementChild) === null || _a === void 0 ? void 0 : _a.firstElementChild;
            const tab = tabsContainer === null || tabsContainer === void 0 ? void 0 : tabsContainer.children[value];
            if (tab === null || tab === void 0 ? void 0 : tab.firstElementChild) {
                setTabIndicatorWidth(tab.firstElementChild.clientWidth);
            }
        }
    }, [tabIndicatorRef.current, value]);
    return (React.createElement(Box, { position: "relative" },
        React.createElement(Tabs, Object.assign({ classes: {
                root: classes.tabsRoot,
                indicator: classes.tabIndicator,
                flexContainer: classes.tabsContainer,
                scrollButtons: classes.scrollButtons,
            }, value: value, indicatorColor: "primary", innerRef: tabIndicatorRef, variant: variant, TabIndicatorProps: {
                style: tabIndicatorWidth
                    ? {
                        zIndex: 1,
                        clip: `rect(0px, ${value > 0
                            ? `${tabIndicatorWidth + 12}px`
                            : `${tabIndicatorWidth}px`}, 2px, ${value > 0 ? "12px" : "0"})`,
                    }
                    : { zIndex: 1 },
            } }, props)),
        React.createElement(Divider, { absolute: true, style: { height: "2px", backgroundColor: "#E3E5E8" } })));
};
export const FTLTab = (props) => {
    const classes = useStyles();
    return (React.createElement(Tab, Object.assign({ classes: {
            root: classes.tab,
            selected: classes.selectedTab,
            wrapper: classes.tabText,
        } }, props)));
};
const useStyles = makeStyles((theme) => ({
    tabsRoot: { minHeight: "32px" },
    tabsContainer: {
        "& button": {
            whiteSpace: "nowrap",
            "&:first-child": { paddingLeft: `0 !important` },
        },
    },
    tab: {
        color: `${palette.tabs.enabled} !important`,
        minHeight: "32px",
        minWidth: "auto",
        padding: "6px 12px !important",
    },
    tabText: Object.assign({ textTransform: "none" }, theme.typography.buttonTextSecondary),
    selectedTab: {
        color: `${theme.palette.primary.main} !important`,
    },
    tabIndicator: {
        borderRadius: "2px",
    },
    scrollButtons: {
        width: 32,
        height: 32,
        color: theme.palette.icon.secondary,
        transition: "width 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "&.Mui-disabled": {
            width: 0,
        },
    },
}));
//# sourceMappingURL=FTLTabs.js.map